import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Button';
import { AuthContext } from '../../../../contexts/AuthContext';
import {
  Modules,
  AuthRoutes,
  RouteParamsTypes,
  PermissionModulesEnum,
  PermissionActionsEnum,
  RoleCodes,
} from '../../../../enums';
import { hasResourseAccess } from '../../../../utils/methods';
import SyncPropertiesModal from './SyncPropertiesModal';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const { isSystemAdmin, permissions, loggedInUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [syncModalOpen, setSyncModalOpen] = useState<boolean>(false);

  const hasAddAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.Properties]: [PermissionActionsEnum.Add] }],
  });

  const hasSyncAccess =
    isSystemAdmin === 'true' || loggedInUser?.role?.code === RoleCodes.admin;

  const handleAddNewClick = (e?: any) => {
    const url = Modules.properties + AuthRoutes.properties + RouteParamsTypes.add;
    if (e && (e.ctrlKey || e.metaKey)) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  };

  return (
    <>
      <div className="row mb-6">
        <div className="col-6">
          <h4 className="m-0 fw-bold">{t('properties.list.pageTexts.header.title')}</h4>
          <p>{t('properties.list.pageTexts.header.subTitle')}</p>
        </div>
        <div className="col-6 d-flex align-items-center justify-content-end gap-2">
          {hasSyncAccess && (
            <Button
              className="btn btn-outline-primary waves-effect waves-light"
              onClick={() => setSyncModalOpen(true)}
              text={t('properties.list.pageTexts.header.syncButton')}
            />
          )}
          {hasAddAccess && (
            <div className="add-new">
              <Button
                className="btn btn-primary waves-effect waves-light"
                onClick={handleAddNewClick}
                text={t('properties.list.pageTexts.header.addNewButton')}
              />
            </div>
          )}
        </div>
      </div>

      {hasSyncAccess && (
        <SyncPropertiesModal
          open={syncModalOpen}
          onClose={() => setSyncModalOpen(false)}
        />
      )}
    </>
  );
};

export default Header;
